import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import { IOpeningCardList } from "@/components/cards/CurrentOpeningCard";
import HtmlText from "../common/HtmlText";

// --------------------------------------------------------------------------------------------------

export type ICareerDetailSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  criteriaList?: IOpeningCardList[];
};

const CareerDetailSection: FC<ICareerDetailSectionProps> = (props) => {
  const { heading, description, criteriaList, className, ...other } = props;

  return (
    <section
      className={clsx("py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="container">
        {criteriaList && criteriaList.length > 0 && (
          <div className="mb-5 grid gap-y-3 pl-2 md:grid-cols-2 md:gap-x-5 lg:mb-8 lg:grid-cols-3 lg:gap-y-4 xl:mb-10 xl:gap-x-8 xl:gap-y-6">
            {criteriaList.map((item, idx) => (
              <div key={idx} className="flex items-center">
                <span className="active relative block h-2 w-2 rounded-full bg-yellow-400 after:absolute after:-left-[4px] after:-top-[4px] after:h-4 after:w-4 after:rounded-full after:border-2 after:border-blue-900"></span>
                <p className="pl-4 text-base font-normal text-primary-900 xl:text-h7 2xl:text-h5">
                  {item.key} :
                  <span className="ml-1 text-black-900">{item.value}</span>
                </p>
              </div>
            ))}
          </div>
        )}

        {(heading || description) && (
          <div>
            {heading && (
              <h2 className="mb-5 text-h5 font-normal text-black-900 lg:mb-7 lg:text-h3 xl:text-h2">
                {heading}
              </h2>
            )}

            {description && <HtmlText>{description}</HtmlText>}
          </div>
        )}
      </div>
    </section>
  );
};

export default CareerDetailSection;
